import { Post } from '@/service/request/server';
import { envConfig } from '../../../env';
import { EnumContentType } from '@/constant/enums';

export function insertAdvice(advert) {
    return Post(envConfig.formalServer + "/cotton/insertAdvert", advert, {
        headers: {
            'Content-Type': EnumContentType.formData
        }
    })
}

export function modifyAdviceById(advert) {
    return Post(envConfig.formalServer + "/cotton/modifyAdvertById", advert, {
        headers: {
            'Content-Type': EnumContentType.formData
        }
    })
}

export function getAllAdvert(advert) {
    return Post(envConfig.formalServer + "/cotton/getAllAdvert", advert)
}

/**
 * 删除广告
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export function deleteAdvert(data) {
    return Post(envConfig.formalServer + "/cotton/deleteAdvert", data)
}